import { webPlatformAdapterBuilderAsync } from "@sia/style-guide";
import KeycloakIDPAdapter from "../IDPAdapter/KeycloakIDPAdapter";

const apiUrl = process.env.REACT_APP_WEB_PLATFORM_API_URL;

const webPlatformAdapterAsync = webPlatformAdapterBuilderAsync(KeycloakIDPAdapter, apiUrl);
export default webPlatformAdapterAsync;
